import request from '@/config';

enum Apis {
	Create = `/api/mainstay/createmainstay`,
	Modify = `/api/mainstay/modifymainstay`,
	List = `/api/mainstay/getlist`,
	Detail = `/api/mainstay/getdetail`,
	Delete = `/api/mainstay/deletemainstay`,
	SelectList = `/api/mainstay/getselectlist`,
	StampList = `/api/mainstay/getstamplist`,
	MainstayCache = `/api/mainstay/getmainstaycachelist`,
}

const MainstayCreateApi = (createData: any): Promise<IResponse> => request.post({ url: Apis.Create, data: createData });
const MainstayModifyApi = (editData: any): Promise<IResponse> => request.post({ url: Apis.Modify, data: editData });
export const GetMainstayCacheApi = (): Promise<IResponse> => request.post({ url: Apis.MainstayCache, data: {} });

const MainstayDelApi = (delData: any): Promise<IResponse> => {
	return request.post({ url: Apis.Delete, data: delData });
};

const GetMainstayInfoApi = (rowId: string): Promise<IResponse> => {
	return request.post({ url: Apis.Detail, data: { id: rowId } });
};

const GetMainstayListApi = (search: any): Promise<IResponse> => {
	return request.post({ url: Apis.List, data: search });
};

const GetMainstaySelectApi = (searchKey: string): Promise<IResponse> => {
	return request.post({ url: Apis.SelectList, data: { search_key: searchKey } });
};

/* 获取主体可用印章列表 */
const GetStampSelectsApi = (mainstayId: string): Promise<IResponse> => {
	return request.post({ url: Apis.StampList, data: { id: mainstayId } });
};

export { MainstayCreateApi, MainstayModifyApi, MainstayDelApi, GetMainstayInfoApi, GetMainstayListApi, GetMainstaySelectApi, GetStampSelectsApi };
